import React from 'react';
import { getAdminBadge } from '../../utils/getAdminBadge';

const GIQuestionHeader = ({
  questionId,
  questionText,
  questionType,
  badgeLabel,
  adminBadge,
  isCollapsed = false,
  onToggleCollapse
}) => {
  return (
    <div className="bg-gray-50 dark:bg-gray-700 p-4 border-b border-gray-200 dark:border-gray-600">
      <div className="flex justify-between items-start text-left gap-3">
        <div className="text-left">
          <h4 className="font-medium text-gray-800 dark:text-gray-200 text-left">
            {adminBadge && getAdminBadge()} {questionText}
          </h4>
          {/* <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 text-left">
            Question #{questionId} • Type: {questionType}
          </p> */}
        </div>
        <div className="flex items-center gap-2">
          {typeof onToggleCollapse === 'function' && (
            <button
              type="button"
              onClick={onToggleCollapse}
              className="inline-flex items-center justify-center w-8 h-8 rounded-md border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              aria-label={isCollapsed ? 'Expand item' : 'Collapse item'}
              aria-expanded={!isCollapsed}
              title={isCollapsed ? 'Expand' : 'Collapse'}
            >
              <svg
                className={`w-4 h-4 transition-transform ${isCollapsed ? '' : 'rotate-180'}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          )}
          <div className="text-xs bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-2 py-1 rounded">
            {badgeLabel}
          </div>
          <div className="text-xs bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-2 py-1 rounded">
            #{questionId}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GIQuestionHeader;